import React from 'react';
import '../styles/Projects.css';

const Projects = () => {
  const projects = [
    {
      title: "Strava Heat Map",
      description: "Strava has a premium subscription that costs $13/month (more than a poor college student can afford). My favorite feature included with the premium subscription is a heat map of activities, so I created an API to request all of my activities from Strava, which I then used to make my own heat map of the activities.",
      link: "https://github.com/will-hagedorn/Strava-Heat-Map"
    },
    {
      title: "Simple DBMS",
      description: "Created a simple Database Management System with 2 friends",
      link: "https://github.com/will-hagedorn/simple_dbms"
    },
    {
      title: "Calculator Chrome Extension",
      description: "I got tired of digging out my calculator every time I needed to check some simple arithmetic, so I created a pop-up chrome extension utilizing HTML, CSS, and ReactJS.",
      link: "https://github.com/will-hagedorn/CalculatorChromeExtension"
    },
    {
      title: "Basic Pace Calculator",
      description: "As an avid runner and biker, I often need to calculate my paces. I'm not a huge fan of the UI of any of the calculators that can be eaily flound through a Google search. So I made my own utilizing HTML, CSS, and JavaScript.",
      link: "https://github.com/will-hagedorn/PaceCalculator"
    },
    {
      title: "First Personal Website Attempt",
      description: "This was my first personal website, created using HTML and CSS.",
      link: "https://github.com/will-hagedorn/hags-money.github.io"
    }
  ];

  return (
    <section id="projects" className="projects-section">
      <h2>Projects</h2>
      {projects.map((project, index) => (
        <div key={index} style={{ marginBottom: '1.5rem' }}>
          <h3>{project.title}</h3>
          <p>{project.description}</p>
          <a href={project.link}>Check it out →</a>
        </div>
      ))}
    </section>
  );
};

export default Projects;
